module.exports = __webpack_public_path__ + "img/solution28804.9f66b702.png";